import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { TealiumButton } from '@grandvisionhq/svc-tealium/components';
import { getButtonVariant, getButtonColor } from './helpers.js';
import SiteNavItem from './SiteNavItem/SiteNavItem.js';
import SiteNavMobile from './SiteNavMobile/SiteNavMobile.js';

const SiteNav = ({ menuItems , appointmentItems , routes , countrySwitcherOptions , renderCartButton , renderWishlistMenuItem , ordersUrl ,  })=>{
    const { getLabel  } = useIntl();
    const navLabel = getLabel('common.screenreader.siteNavigationDesktop', {
        hideLabelKey: true
    });
    const breakpoint = MediaQuery.useBreakpoint();
    const isMobile = breakpoint === MediaQuery.BreakpointName.PHONE || breakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT;
    const [activeSubMenu, setActiveSubMenu] = React.useState('');
    /**
   * This onBlur handler is to catch two edge cases:
   * * tab on the last focusable element on the last submenu (would not be caught
   *   by an onFocus of another main menu entry like other submenus
   * * shift-tab on the first focusable element on the first submenu (when, of
   *   course, the first main entry is one with a submenu)
   * The handler checks if focus has fallen out of the complete site-nav__menu element
   */ const onBlur = React.useCallback((e)=>{
        const currentTarget = e.currentTarget;
        requestAnimationFrame(()=>{
            if (!currentTarget.contains(document.activeElement)) setActiveSubMenu('');
        });
    }, [
        setActiveSubMenu
    ]);
    const focusCallback = (label)=>()=>{
            if (activeSubMenu !== label) setActiveSubMenu('');
        }
    ;
    if (isMobile) {
        return /*#__PURE__*/ React.createElement(SiteNavMobile, {
            routes: routes,
            ctaItems: appointmentItems,
            menuItems: menuItems,
            countrySwitcherOptions: countrySwitcherOptions,
            renderCartButton: renderCartButton,
            renderWishlistMenuItem: renderWishlistMenuItem,
            ordersUrl: ordersUrl
        });
    }
    return /*#__PURE__*/ React.createElement("nav", swcHelpers.extends({
        className: "site-nav",
        "data-t": "site-nav"
    }, navLabel && {
        'aria-label': navLabel
    }), /*#__PURE__*/ React.createElement("div", {
        className: "site-container site-nav__container"
    }, /*#__PURE__*/ React.createElement("ul", {
        className: "site-nav__menu",
        onBlur: onBlur
    }, menuItems.map((item)=>/*#__PURE__*/ React.createElement(SiteNavItem, swcHelpers.extends({
            key: item.label
        }, item, {
            focusCallback: focusCallback(item.label),
            activeSubMenu: activeSubMenu,
            setActiveSubMenu: setActiveSubMenu
        }))
    )), appointmentItems && /*#__PURE__*/ React.createElement("div", {
        className: "site-nav__appointment",
        "data-t": "site-nav-appointment"
    }, appointmentItems.map((item)=>{
        var ref, ref1;
         return React.createElement(TealiumButton, {
            key: item.label,
            icon: (ref = item.parameters) === null || ref === void 0 ? void 0 : ref.icon,
            className: ((ref1 = item.parameters) === null || ref1 === void 0 ? void 0 : ref1.icon) && 'site-nav__appointment-btn',
            href: item.link && item.link.href,
            caption: item.label,
            variant: getButtonVariant(item),
            color: getButtonColor(item),
            tealiumEvent: {
                data_element_id: 'MainNav_OEE_Open'
            }
        });
    }))));
};

export { SiteNav, SiteNav as default };
//# sourceMappingURL=SiteNav.js.map
